import { render, staticRenderFns } from "./address.vue?vue&type=template&id=3dac2b6a&scoped=true&"
import script from "./address.vue?vue&type=script&lang=js&"
export * from "./address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dac2b6a",
  null
  
)

export default component.exports